<template>
  <div style="display: flex; align-items: center; margin-left: 0; margin-right: 0; padding-left: 0; padding-right: 0" v-if="isViewFollowButton">
    <button type="button" @click="onFollowButton" class="btn btn-link">
      <small class="" v-if="dtoUser.isFollowedByLoginUser">フォロー中</small>
      <small v-else>フォローする</small>
    </button>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import UserResp from "@/interface/api/UserResp";
import RootVue from "@/RootVue.vue";

@Options({
  components: {
  },
  props: {
    dtoUser: {
      type: Object,
    },
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  readonly dtoUser!: UserResp;

  get isViewFollowButton() {
    // ログアウト中は表示しない
    if (!this.$root.account.isLogin) {
      return false;
    }
    // 自分自身ではないかのチェック
    return this.$root.account.info.userName != this.dtoUser.userName;
  }

  // フォローする
  followUser() {
    this.$root.restAccess.followUser(this.dtoUser.userName).then((res) => {
      // ログインしていない場合確認。
      if (res.status === 403) {
        this.$root.account.reload();
        return;
      }
      // エラー
      if (res.status >= 400) {
        return;
      }
      console.log("フォロー : ", res);
      this.dtoUser.isFollowedByLoginUser = true;
    });
  }
  // フォローを外す
  unFollowUser() {
    this.$root.restAccess.unFollowUser(this.dtoUser.userName).then((res) => {
      if (res.status === 403) {
        this.$root.account.reload();
        return;
      }
      if (res.status >= 400) {
        return;
      }
      console.log("フォロー解除 : ", res);
      this.dtoUser.isFollowedByLoginUser = false;
    });
  }

  // フォローボタンを押したとき
  onFollowButton(e: any) {
    // フォローしていたら解除、していなかったらフォロー
    if (this.dtoUser.isFollowedByLoginUser) {
      console.log("unfollow");
      this.unFollowUser();
    } else {
      this.followUser();
    }
    e.currentTarget.blur();
  }
}
</script>